<template>
  <card :has-settings="false" :has-subtitle="false" auto-height title="Patient Note">
    <template #headerUtils v-if="$can('Edit', 'PatientMonitor') && patient">
      <button class="button is-outlined is-primary" :class="{'is-focused': editMode}" @click="editMode = true">Edit</button>
    </template>
    <template #content>
      <div v-if="editMode">
        <input-with-validation field-label="" b-name="input" v-model="note" placeholder="Write Note" :rules="{ max: 150 }" maxlength="150"></input-with-validation>
        <div class="is-flex is-justify-content-center">
          <button class="button is-white" @click="cancel">Cancel</button>
          <button class="button is-primary" @click="save">Save</button>
        </div>
      </div>
      <div v-else>
        <p class="note" v-if="note">{{ note }}</p>
        <div v-else class="no-data-message">
          <p>Patient monitor doesn't have a note</p>
        </div>
      </div>
    </template>
  </card>
</template>

<script>
import Card from "@/components/card/Card";
import InputWithValidation from "@/components/validation/InputWithValidation";
import to from "@/lib/to";
import { EVENTS, EventBus } from "@/lib/EventBus";
export default {
  name: "PatientNote",
  components: {InputWithValidation, Card},
  props: {
    patient: {
      type: Object
    },
    monitorId: {
      type: Number,
      required: false,
      default: null
    }
  },
  watch: {
    patient: {
      handler(newVal) {
        if (newVal) {
          this.note = this.originalNote = this.patient.note
        }
      },
      immediate: true
    },
  },
  methods: {
    async save() {
      const [err, ] = await to(this.$http.post(`/patients/${this.patient.id}/save_note`, { note: this.note }))
      if (!err) {
        this.originalNote = this.note
        this.editMode = false
        if (this.monitorId) {
          EventBus.$emit(EVENTS.RELOAD_WIDGET_MONITOR_DATA, this.monitorId)
        }
        this.$buefy.toast.open({
          message: 'Note saved successfully',
          type: 'is-success'
        });
      }
    },
    cancel() {
      this.note = this.originalNote
      this.editMode = false
    }
  },
  data() {
    return {
      note: '',
      originalNote: '',
      editMode: false
    }
  }
}
</script>
<style scoped>
.note {
  font-size: 14px;
  line-height: 18px;
}
</style>
